import { useRef } from "react"
import ReplayTaskDescription from "./components/ReplayTaskDescription"
import ReplayTestCases from "./components/ReplayTestCases"
import ReplayCodeEditor from "./components/ReplayCodeEditor"
import ReplayTerminal from "./components/ReplayTerminal"
import ReplayChatWindow from "./components/ReplayChatWindow"
import ReplayMouseLayer from "./components/ReplayMouseLayer"
import { usePanelResize } from "../workspace/hooks/usePanelResize"
import '../workspace/css/workspace.scss'

export default function ReplayWorkspace() {
  const containerRef = useRef(null)
  const layout = usePanelResize(containerRef)

  return (
    <div className="ws-container">
      <div 
        className="ws-content" 
        id="replay-ws-content" 
        ref={containerRef}
        style={{ position: 'relative' }}
      >
        <ReplayMouseLayer />
        
        {/* LEFT PANEL */}
        <div className="ws-panel-left" style={{ width: `${layout.leftWidth}px` }}>
          <div className="ws-panel-content">
            <ReplayTaskDescription />
            <div className="ws-section-divider"></div>
            <ReplayTestCases />
          </div>
        </div>

        <div className="ws-resizer ws-horizontal" onMouseDown={layout.startDraggingLeft} />

        {/* MIDDLE PANEL */}
        <div className="ws-middle-panel" style={{ minWidth: '400px' }}>
          <ReplayCodeEditor />
          <ReplayTerminal height={layout.terminalHeight} />
          <div 
            className="ws-resizer ws-vertical"
            style={{ position: 'absolute', bottom: layout.terminalHeight, left: 0, right: 0, zIndex: 30 }}
            onMouseDown={layout.startDraggingTerminal}
          />
        </div>

        <div className="ws-resizer ws-horizontal" onMouseDown={layout.startDraggingRight} />

        {/* RIGHT PANEL */}
        <div className="ws-panel-right" style={{ width: `${layout.rightWidth}px` }}>
          <ReplayChatWindow />
        </div>
      </div>
    </div>
  )
}